import { render, staticRenderFns } from "./AddRolePopup.vue?vue&type=template&id=1e033cc7&"
import script from "./AddRolePopup.vue?vue&type=script&lang=js&"
export * from "./AddRolePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports